import Status from "@/modules/common/components/ui-kit/status/status";
import ActivityDetailsText from "@/modules/lead-page/new/components/activity/activity-details-typography";
import UserNameTag from "@/modules/lead-page/new/components/activity/user-name-tag";
import { Stack, useTheme } from "@mui/material";
import { useMemo } from "react";

interface ActionUpdateDetailsProps {
  actor: {
    name: string | null;
    color: string | null;
  };
  action: {
    name: string;
    color: string | null;
  };
}
const ActionUpdateDetails = ({ actor, action }: ActionUpdateDetailsProps) => {
  const theme = useTheme();

  const hasActorName = Boolean(actor.name);

  const changeText = useMemo(() => {
    return hasActorName ? "set the action to" : "Action set to";
  }, [hasActorName]);

  return (
    <Stack
      direction="row"
      spacing={theme.nawy.spacing.xxs}
      flexWrap="wrap"
      alignItems="center"
    >
      {actor.name && <UserNameTag name={actor.name} color={actor.color} />}

      <ActivityDetailsText>{changeText}</ActivityDetailsText>

      <Status
        label={action.name}
        bgHexColor={action.color || ""}
        size="md"
        width="auto"
      />
    </Stack>
  );
};

export default ActionUpdateDetails;
